import { UserGamificationLevel } from './../../../services/profile/profile.models';
import { ChangeDetectorRef, Component, ElementRef, Inject, NgZone, PLATFORM_ID, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { BasePageComponent } from '../../base-page/base-page.component';
import { delay, distinctUntilChanged, map, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { MinimizeSiteService } from 'src/app/services/utils/hide-footer.service';
import { isPlatformServer } from '@angular/common';
import { Observable, Subject, concat, interval, of, timer } from 'rxjs';
import { GamificationLevelService } from 'src/app/services/profile/gamification-level.service';

const LEVEL_NAMES = ['green', "yellow", "bronze", "silver", "gold", "diamond"];

@Component({
  selector: 'app-gamification-progress',
  templateUrl: './gamification-progress.component.html',
  styleUrls: ['./gamification-progress.component.scss']
})
export class GamificationProgressComponent extends BasePageComponent {

  isServer: boolean;
  progressPercentage$: Observable<number>;
  source = interval(100);
  playerLoyalityName: string;
  isHidden: boolean = false;
  gamificationIndexSubject = new Subject<number>();
  gamificationIndex$ = this.gamificationIndexSubject.asObservable();
  iconNameIndex:number;
  prevGamification: UserGamificationLevel;
  currentGamification: UserGamificationLevel;

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    protected translationConfig: TranslationConfig,
    protected minimizeService: MinimizeSiteService,
    private gamificationLevelService: GamificationLevelService,
    @Inject(PLATFORM_ID) private platformId,
    private ngZone: NgZone,
  ) { super() }


  ngOnInit(): void {
    console.log('GamificationProgressComponent INIT');

    this.isServer = isPlatformServer(this.platformId);

    this.minimizeService.isToolbarNotMinimized().pipe(takeUntil(this.unsubscribe)).subscribe((isNotMinimized) => {
      this.isHidden = !isNotMinimized;
    })

    this.prevGamification = this.gamificationLevelService.getArchivedValue();
    this.currentGamification = this.gamificationLevelService.getCurrentValue();
    this.iconNameIndex = this.getLemonIconNameIndex(this.prevGamification?.levelNumber);
    this.gamificationIndex$ = of(this.prevGamification?.levelNumber);
    const index = Math.max(0, Math.min(Math.floor((this.prevGamification?.levelNumber - 1) / 5), LEVEL_NAMES.length - 1));
      this.playerLoyalityName = LEVEL_NAMES[index];
  }

  ngAfterViewInit() {
    if (!this.isServer) {
      this.ngZone.runOutsideAngular(() => {
      });

      let levelDifference = this.currentGamification?.levelNumber - this.prevGamification?.levelNumber;
      let observables = [];

      observables.push(
        this.source.pipe(
          take(1),
          map(value => Math.round(this.prevGamification?.turnover / this.prevGamification?.levelEndsTurnover * 100))
        )
      );

      for (let index = 0; index <= levelDifference; index++) {
        let gamificationIndex = this.prevGamification?.levelNumber + index;
        let percentage = levelDifference > 0 && index < levelDifference ? 100 : Math.round(this.currentGamification?.turnover / this.currentGamification?.levelEndsTurnover * 100);
        let startPosition = index === 0 ? Math.round(this.prevGamification?.turnover / this.prevGamification?.levelEndsTurnover * 100) : 0;

        observables.push(
          this.source.pipe(
            take(percentage - startPosition),
            map(value => startPosition + value + 1),
            delay(300),
            tap(() => {
              this.iconNameIndex = this.getLemonIconNameIndex(gamificationIndex);
              this.gamificationIndex$ = of(gamificationIndex)
              this.gamificationIndexSubject.next(gamificationIndex);
            })
          )
        );
      }

      observables.push(
        this.source.pipe(
          take(1),
          delay(3000),
          tap(() => {
            this.gamificationLevelService.cleanArchivedValue();
          })
        )
      );

      this.progressPercentage$ = concat(...observables) as Observable<number>;
      this.cdr.detectChanges();
    }
  }



  redirectToProfile(): void {
    this.router.navigate(['', 'client-area', 'main']);
  }

  getLemonIconNameIndex(gamifiactionIndex): any | number {
    return Math.ceil(gamifiactionIndex / 5);
  }
}
